// @flow
import { useCurrencySign } from 'app/common/components-next/currency';
import { useTranslation } from 'react-i18next';


const ids = [
  'id',
  'date',
  'who',
  'group',
  'foodMode',
  'total',
  'info',
];

const idsSkipInfo = ids.slice(0, -1);

export const useColumns = (showInfo?: boolean): Array<string> => (
  showInfo ? ids : idsSkipInfo
);

export const useTitles = (): Array<string> => {
  const currency = useCurrencySign();
  const { t } = useTranslation('cafeteria');
  const tableHeaders = t('order_requests_table_columns', { returnObjects: true, currency });

  return tableHeaders;
};
